import api from './api'
import type { Crew, CrewMember } from '@/types'

interface CreateCrewPayload {
  name: string
  description?: string
}

interface UpdateCrewPayload {
  name?: string
  description?: string
}

interface AddCrewMemberPayload {
  pricingItemId: string
  quantity: number
  role?: string
}

export const crewsService = {
  async list() {
    const { data } = await api.get('/crews')
    return data.data as Crew[]
  },

  async getById(id: string) {
    const { data } = await api.get(`/crews/${id}`)
    return data.data as Crew
  },

  async create(payload: CreateCrewPayload) {
    const { data } = await api.post('/crews', payload)
    return data.data as Crew
  },

  async update(id: string, payload: UpdateCrewPayload) {
    const { data } = await api.put(`/crews/${id}`, payload)
    return data.data as Crew
  },

  async remove(id: string) {
    await api.delete(`/crews/${id}`)
  },

  async addMember(crewId: string, payload: AddCrewMemberPayload) {
    const { data } = await api.post(`/crews/${crewId}/members`, payload)
    return data.data as CrewMember
  },

  async removeMember(crewId: string, memberId: string) {
    await api.delete(`/crews/${crewId}/members/${memberId}`)
  },
}
